// extracted by css-extract-rspack-plugin
var _1 = "cq";
var _2 = "cp";
var _3 = "co";
export { _1 as "afix", _2 as "categoryBottomBelt", _3 as "shoppingMallTabOffersComponent" }
